export function Commission() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Commission</h2>
      <p className="text-gray-600">Commission + payouts dashboard — to be implemented in Phase 4.</p>
    </div>
  );
}